import * as stylex from "@stylexjs/stylex";
import { type Breakpoint, layoutSize } from "@/domain/breakpoint";
const grids = {
  large: {
    kumcoG: "x1pfssu3",
    kAzted: "x1us19tq",
    $$css: true
  },
  small: {
    kumcoG: "x1mkdm3x",
    $$css: true
  }
};
const hourly = {
  fit: {
    kumcoG: "x1grqvj",
    $$css: true
  },
  scroll: {
    kumcoG: "x1v89453",
    kXHlph: "xw2csxc",
    $$css: true
  }
};
const daily = {
  fit: {
    kumcoG: "x1gj6vdr",
    $$css: true
  },
  scroll: {
    kumcoG: "x1mp6zv7",
    kXHlph: "xw2csxc",
    $$css: true
  }
};
export function weatherLayout(breakpoint: Breakpoint) {
  const size = layoutSize(breakpoint);
  const fit = size === "small" ? "scroll" : "fit";
  return {
    grid: grids[size],
    hourly: hourly[fit],
    daily: daily[fit]
  };
}